import { CompanyFact } from "../../../interfaces/team";
import { useCompanyFactMainz } from "./facts/mainz";
import { useCompanyFactNameMeaning } from "./facts/nameMeaning";
import { useCompanyFactWorkHere } from "./facts/workHere";

export const useCompanyFacts = (): CompanyFact[] => [
  useCompanyFactNameMeaning(),
  useCompanyFactMainz(),
  useCompanyFactWorkHere(),
];
